var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 24c6.629 0 12-5.371 12-12S18.629 0 12 0 0 5.371 0 12s5.371 12 12 12ZM6.116 8.85a.581.581 0 0 1 0-.823l1.916-1.91a.581.581 0 0 1 .823 0L12 9.29l3.15-3.174a.581.581 0 0 1 .823 0l1.91 1.916a.581.581 0 0 1 0 .823L14.71 12l3.174 3.15a.581.581 0 0 1 0 .823l-1.916 1.916a.581.581 0 0 1-.823 0L12 14.709l-3.15 3.175a.581.581 0 0 1-.823 0l-1.916-1.916a.581.581 0 0 1 0-.823L9.291 12 6.115 8.85Z",
  fill: "#EB2F96"
})));

export default SvgClose;